export type IncrementalIntervalCancelFn = () => void;

export function setIncrementalInterval(
  listener: () => void,
  map: Record<number, number>,
) {
  let index = 0;
  const intervalId: ReturnType<typeof setInterval> | null = null;
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  function nextTimeout() {
    const timeout = map[index++] ?? map[Object.keys(map).length - 1];
    listener();

    timeoutId = setTimeout(nextTimeout, timeout);
  }

  const cancel: IncrementalIntervalCancelFn = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  };

  nextTimeout();
  return cancel;
}
